module.exports = __webpack_public_path__ + "img/bg_yixiubao_yuan.cc4541cb.svg";